import { Paper, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DrawerPaper = styled(Paper)(({ theme }) => ({
  maxWidth: '640px',
  width: '100%',
  marginTop: 0,
  [theme.breakpoints.down('md')]: {
    maxWidth: '93%',
    width: '93%',
    marginTop: '60px',
  },
}));

export const DrawerLayout = styled(Grid)({ flexDirection: 'column', flex: '1 1' });
export const DrawerHeader = styled(Grid)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
}));
export const DrawerTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightSemiBold,
  fontSize: 18,
}));
export const DrawerActions = styled(Grid)({ alignItems: 'center' });
export const DrawerContent = styled(Grid)(({ theme }) => ({
  flex: '1 1',
  padding: theme.spacing(2),
}));
